<template>
  <v-sheet
    class="pa-4 event-sheet"
    style="border: 1px solid black;"
    :color="event.LandingPageColor"
  >
    <v-row>
      <v-col class="event-header" cols="12">
        <h2
          :class="{
            'event-title': true,
            'white--text': event.LandingPageTextColor == 'light'
          }"
        >
          {{ event.Title }}
        </h2>
        <h2
          :class="{
            'event-price': true,
            'white--text': event.LandingPageTextColor == 'light'
          }"
        >
          {{ event.MinPrice | toCurrency }}
          <span v-if="event.MaxPrice > event.MinPrice">
            - {{ event.MaxPrice | toCurrency }}</span
          >
        </h2>
      </v-col>
    </v-row>
    <v-row class="event-dates-row">
      <v-col class="event-dates-col" cols="12">
        <v-divider class="my-2 event-divider"></v-divider>
        <v-row v-if="event.EventID !== 9376">
          <v-col cols="12" md="4">
            <h3
              :class="{
                'white--text': event.LandingPageTextColor == 'light',
                'my-2': true
              }"
            >
              {{ event.minDate }}
            </h3>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="event-dates-col" cols="12">
        <v-btn depressed :to="event.BookingUrl" color="primary">Select</v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
export default {
  props: ["event"]
};
</script>
<style scoped>
.tempo-subtitle {
  color: #919699;
  font-size: 15px;
}
.tempo-subtitle-light {
  color: #d3e3eb;
  font-size: 15px;
}
.tempo-badge {
  color: #0b5289;
}

.event-sheet {
  width: 80%;
  border: 1px solid black !important;
}

.event-header {
  display: flex;
}
.event-title {
  flex: 1;
  width: 80%;
  justify-content: flex-start;
}
.event-price {
  display: flex;
  justify-content: flex-end;
}
.event-dates-col {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.event-divider {
  margin-top: 6px !important;
  margin-bottom: 8px !important;
}
.event-sheet .row:last-child {
  margin-top: 0;
  margin-bottom: 4px !important;
}

/* Mobile styling */
@media (max-width: 600px) {
  .event-sheet {
    width: 100%;
  }
}
</style>
